const REFERRAL_CODE_KEY = "synergycoin:referralCode";

const normalizeCode = (value) => {
  if (typeof value !== "string") return "";
  return value.trim().toUpperCase();
};

export const saveReferralCode = (code) => {
  if (typeof window === "undefined") return;
  const normalized = normalizeCode(code);
  if (!normalized) return;
  try {
    window.localStorage.setItem(REFERRAL_CODE_KEY, normalized);
  } catch (error) {
    // ignore storage write errors
  }
};

export const getReferralCode = () => {
  if (typeof window === "undefined") return "";
  try {
    const stored = window.localStorage.getItem(REFERRAL_CODE_KEY);
    return normalizeCode(stored || "");
  } catch (error) {
    return "";
  }
};

export const clearReferralCode = () => {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(REFERRAL_CODE_KEY);
  } catch (error) {
    // ignore storage write errors
  }
};

export const hasReferralCode = () => Boolean(getReferralCode());
